export default __webpack_public_path__ + "img/7e06a2e180b834e7051821c0677d9c30.svg";